// extracted by mini-css-extract-plugin
export var tabs = "tabs-module--tabs--kGEeV";
export var header = "tabs-module--header--1nPV8";
export var active = "tabs-module--active--3ihXP";
export var content = "tabs-module--content--3O7t_";